/**
 * Adjust handler direction.
 * When adjust handler is moved, its movement direction decides the computation against its corresponding adjust value.
 */
export enum IAdjustHandlerDirection {
    /** from top to bottom OR from left to right */
    FORWARD = "FORWARD",
    /** from bottom to top OR from right to left */
    REVERSE = "REVERSE",
    /** Adjust handlers are relative to center. */
    CENTER = "CENTER",
};
